export enum DebugTools {
    DRAWING = 'drawing',
    LIVE_CURSOR = 'liveCursor',
    ZOOM = 'zoom',
    DND = 'dnd',
    MOBILE_KEYBOARD_ANIMATION = 'mobileKeyboardAnimation',
    TIPTAP_EDITOR = 'tiptapEditor',
    SHARE_EXTENSION = 'shareExtension',
    TOAST = 'toast',
    LINES = 'lines',
    COMMENTS = 'comments',
    ONBOARDING = 'onboarding',
    MOBILE = 'mobile',
    ELEMENT_PLACEHOLDERS = 'elementPlaceholders',
    TRANSLATION = 'translation',
    LABELS = 'labels',
    TABLE = 'table',
    UNDO_REDO = 'undoRedo',
    ONE_TRUST = 'oneTrust',
}

type DebugToolBaseSettings = {
    lastUpdateTimestamp?: number;
};

export type DebugToolSettings = {
    [DebugTools.DRAWING]: DebugToolBaseSettings & {
        hideOverlay?: boolean;
        showPathPoints?: boolean;
        showStrokePoints?: boolean;
        showPathBoundingBox?: boolean;
        updateAllStrokes?: boolean;
    };
    [DebugTools.LIVE_CURSOR]: DebugToolBaseSettings & {
        showCursorState?: boolean;
    };
    [DebugTools.ZOOM]: DebugToolBaseSettings & {
        showOrigin?: boolean;
        documentView?: boolean;
    };
    [DebugTools.DND]: DebugToolBaseSettings & {
        showAll?: boolean;
        showClientOffset?: boolean;
        showSourceClientOffset?: boolean;
        showElementDragGroupPositioner?: boolean;
        showElementDragPreviewPositioner?: boolean;
        showElementOffset?: boolean;
        showGrabOffset?: boolean;
        showCustomDragOffset?: boolean;
    };
    [DebugTools.MOBILE_KEYBOARD_ANIMATION]: DebugToolBaseSettings;
    [DebugTools.TIPTAP_EDITOR]: DebugToolBaseSettings;
    [DebugTools.SHARE_EXTENSION]: DebugToolBaseSettings;
    [DebugTools.TOAST]: DebugToolBaseSettings;
    [DebugTools.LINES]: DebugToolBaseSettings;
    [DebugTools.COMMENTS]: DebugToolBaseSettings;
    [DebugTools.ONBOARDING]: DebugToolBaseSettings;
    [DebugTools.MOBILE]: DebugToolBaseSettings & {
        simulateMobileKeyboard?: boolean;
        simulateCapacitorSafeAreaBottom?: boolean;
        debugSheetDragAnimation?: boolean;
    };
    [DebugTools.ELEMENT_PLACEHOLDERS]: DebugToolBaseSettings;
    [DebugTools.TRANSLATION]: DebugToolBaseSettings;
    [DebugTools.LABELS]: DebugToolBaseSettings;
    [DebugTools.TABLE]: DebugToolBaseSettings & {
        showCellRendererBadge?: boolean;
    };
    [DebugTools.UNDO_REDO]: DebugToolBaseSettings;
    [DebugTools.ONE_TRUST]: DebugToolBaseSettings;
};

export type DebugToolState = Partial<DebugToolSettings>;
